import type { LinkProps } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@bliks-io/ui';
import { useHistoryBack } from './useHistoryBack';

type BackButtonProps = Pick<LinkProps, 'to' | 'params'>;

export function BackButton({ to, params }: BackButtonProps) {
  const { t } = useTranslation();
  const handleBack = useHistoryBack({ to, params });

  return (
    <Button variant="ghost" size="small" onClick={handleBack}>
      <ArrowLeft className="w-4 h-4" />
      {t('common.Back')}
    </Button>
  );
}
